import { Injectable } from '@angular/core';
import { HttpClient, HttpParams} from '@angular/common/http';
import { SDGComponent } from '../_models/index';
import { environment } from '../../environments/environment';

var URL = environment.url_django;

@Injectable()
export class SummaryService {
    constructor(private http: HttpClient) { }
    getAll() {
    	let user: any ;
        if (localStorage.getItem('currentUserId')) {
            user = JSON.parse(localStorage.getItem('currentUserId'));
        }
        let params = new HttpParams();
        //settings of summary heading is defined only for user_id=1
        params = params.append('team', '1');
        // if (user.team)
        //     params = params.append('team', user.team);
        // else
        //     params = params.append('team', '1');
        return this.http.get<SDGComponent>(URL+'pss_app/team-summary-headings/', {params: params});
    }
}



// WEBPACK FOOTER //
// ./src/app/_services/summary.service.ts